import { useEffect, useState } from "react";

const KEY = "xyz_theme";
const mq = () => window.matchMedia("(prefers-color-scheme: light)");

export const getThemePref = () => localStorage.getItem(KEY) || "dark";
export const resolveTheme = (pref) => (pref === "system" ? (mq().matches ? "light" : "dark") : pref);

export function applyTheme(pref) {
  document.documentElement.dataset.theme = resolveTheme(pref);
  window.dispatchEvent(new CustomEvent("xyz-theme", { detail: pref }));
}

export function setThemePref(pref) {
  localStorage.setItem(KEY, pref);
  applyTheme(pref);
}

export function useTheme() {
  const [pref, setPref] = useState(getThemePref);
  useEffect(() => {
    applyTheme(pref);
    const onChange = (e) => setPref(e.detail);
    const onSys = () => { if (getThemePref() === "system") applyTheme("system"); };
    window.addEventListener("xyz-theme", onChange);
    mq().addEventListener("change", onSys);
    return () => { window.removeEventListener("xyz-theme", onChange); mq().removeEventListener("change", onSys); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return { pref, resolved: resolveTheme(pref), setPref: setThemePref };
}
